export default __webpack_public_path__ + "static/media/gear.eb845b9b.gif";